import type { FaireProductEntity } from "../../entity_types/product";

export const p_se6xajrh2n: FaireProductEntity = {
  token: "p_se6xajrh2n",
  type: "product",
  name: '"Dinner Party" Matches - 28 Strike Matchbox',
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl:
    "https://cdn.faire.com/fastly/16570da9fff6f172c4cd8aaa5a7f0b22da8acaacc6b6eec339a60de3c4218fd3.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bf0b05d317be0db6baf65ee5667899c47b95e4fa8d5ef5ab2f4ee4a0586a5480.jpeg",
    "https://cdn.faire.com/fastly/e377de6be8f83799fa50a65d3f916d2c9611611710d4ece3ce325e800ab34a21.jpeg",
    "https://cdn.faire.com/fastly/c2545709f6e07a013b3f3226584856c1d8a64340b6b5cc74a8d7378355be4ead.jpeg",
    "https://cdn.faire.com/fastly/0efdccd4a6a6f99e215a2ac55741e4a2f0816941b51ffb46c8acecb7301b69b3.jpeg",
  ],
  priceDollars: 3.25,
  description:
    'Matches perfect for celebrating, lighting candles, setting the mood. In your home, office, or on the go.  Features our tomato design on top, and farfalle on the bottom. Features light blue sides with logo and striker. Designed by Mel Andrel in Portland, Maine.\n\n- 2"  x .75" \n- 28 Green Strike Matchsticks',
  tags: [],
  msrpDollars: 6.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:36:26.607Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
